import {Component, computed, Input, signal} from '@angular/core';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.css'
})
export class LoadingComponent {
  @Input() isLoading = false;
  @Input() set dotColors(colors: string[]) {
    this._colors.set(colors);
  }
  @Input() set animationSpeed(speed: number) {
    this._speed.set(speed);
  }

  private _colors = signal(['#1c62f8', '#5890ff', '#3379fa']);
  protected _speed = signal(0.7);

  dots = computed(() =>
      this._colors().map((color, index) => ({
        color,
        delay: (index * this._speed()) / 4
      }))
  );

  trackByFn(index: number, dot: any) {
    return index;
  }
}
